import React from 'react'
import './Error.css'
const Error = () => {
  return (
    <div>Error</div>
  )
}

export default Error